import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { STRINGS } from "../data/content";

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    return window.localStorage.getItem("sc_lang") || "en";
  });

  useEffect(() => {
    window.localStorage.setItem("sc_lang", lang);
    document.documentElement.lang = lang === "pa" ? "pa" : "en";
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      toggle: () => setLang((l) => (l === "en" ? "pa" : "en")),
      t: STRINGS[lang],
    }),
    [lang]
  );

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};

// Simple {token} interpolation helper
export const fill = (str, vars = {}) =>
  str.replace(/\{(\w+)\}/g, (_, k) => (vars[k] !== undefined ? vars[k] : `{${k}}`));
